export const USER_AUTH_TOKEN='UserAuthToken';

export enum UserTypes {
    MANAGER='manager',
    ADMIN ='admin',
    USER='user',
}

export enum Genders {
    MALE ='Male',
    FEMALE='Female'
}

export enum OperatingCity {
    Bangalore = "Bangalore",
    Mysore = "Mysore"
}
export const USER_LOGINID='UserLoginID';

export const USER_ROLE='UserRole';

export const USERNAME='UserName';

export const USER_Production_Role='ProductionRole';


export const Department='Department';

export const fusionAuthUserEmailToken='fusionAuthUserToken';

export const fusionAuthUserAccessToken='fusionAuthUserAccessToken';

